import { useEffect } from "react";

/**
 * Closes any open AG Grid sidebar tool panel when the user clicks outside it.
 * The selected sidebar button is AG Grid's own toggle, so using it keeps the
 * grid's internal open/closed state in sync.
 */
const useGridToolPanelClickAway = () => {
  useEffect(() => {
    const closeOpenToolPanels = (event: MouseEvent) => {
      const target = event.target;
      if (!(target instanceof Element) || target.closest(".ag-side-bar")) return;

      document
        .querySelectorAll<HTMLElement>(".ag-side-bar")
        .forEach((sideBar) =>
          sideBar
            .querySelector<HTMLButtonElement>(".ag-side-button.ag-selected .ag-side-button-button")
            ?.click()
        );
    };

    document.addEventListener("mousedown", closeOpenToolPanels);
    return () => document.removeEventListener("mousedown", closeOpenToolPanels);
  }, []);
};

export default useGridToolPanelClickAway;
